<template>
    <div class="ht-video" @click="openShowDialog">
        <slot>
            <div class="video-box">
                <video class="video" 
                    ref="video" 
                    :src="src" 
                    :controls="isPlay || controls" 
                    :poster="poster"
                    @seeking="seeking" 
                    @seeked="seeked" 
                    @play="play" 
                    @pause="pause"
                ></video>
                <img class="play-icon"  v-if="!isPlay" :src="playIcon" @click="playVideo"/>
            </div>
        </slot>

        <ht-dialog-video :show="showDialog" :src="src" :poster="poster" @close="closeDialog"></ht-dialog-video>
    </div>
</template>

<script>
    import HtDialogVideo from '@/components/HtDialogVideo'
    import playIcon from '@/assets/newPromotionImg/play.svg'

    export default {
        components: {
            HtDialogVideo
        },
        props: {
            // 视频路径
            src: {
                type: String,
                default: ''
            },
            // 封面
            poster: {
                type: String,
                defualt: ''
            },
            // 是否弹窗播放
            isDialogPlay: {
                type: Boolean,
                default: false
            },
            // 是否显示播放控件
            controls: {
                type: Boolean,
                default: true
            },
            playIcon: {
                type: String,
                default: playIcon
            }
        },
        data(){
            return {
                 // 视频播放状态
                isPlay: false,
                // 是否显示视频播放弹窗
                showDialog: false
            }
        },

        methods: {
            openShowDialog(){
                if(!this.isDialogPlay){
                    return
                }
                this.showDialog = true
            },

            closeDialog(){
                this.showDialog = false
            },

            playVideo (){
                this.$refs.video && this.$refs.video.play()
            },

            pauseVideo(){
                this.$refs.video && this.$refs.video.pause()
            },

            play(){
                this.isPlay = true
            },

            seeking(){
                this.isPlay = true
            },

            seeked(){
                console.log(3)
            },

            pause(e){
                this.isPlay = false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .ht-video {
        width: 100%;
        height: 100%;

        .video-box {
            width: 100%;
            height: 100%;
            position: relative;

            .video {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }

            .play-box {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                // pointer-events: none;
            }

            .play-icon {
                width: 18%;
                height: auto;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                cursor: pointer;
            }
        }

        
    }
</style>


// WEBPACK FOOTER //
// src/components/HtVideo/index.vue